import { ProductionFigureThemeSizeConfig } from './types';

const small: ProductionFigureThemeSizeConfig = {
  productionFigure: {},
};

export default small;
